import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

let nextProfileId = 2;
let nextRouteId = 2;

let executionProfiles: Array<Record<string, unknown>> = [
  {
    id: 1,
    user_id: 42,
    name: 'Default Paper Profile',
    description: 'Routes all paper orders through Binance testnet',
    is_default: true,
    created_at: '2026-01-20T09:00:00Z',
    updated_at: '2026-02-15T14:30:00Z',
    routes: [
      {
        id: 1,
        profile_id: 1,
        symbol_pattern: '*',
        venue_connection_id: 1,
        priority: 1,
        execution_mode: 'PAPER',
      },
    ],
  },
];

export const demoExecutionProfilesHandlers = [
  // ── List execution profiles ───────────────────────────────────────────────
  http.get(`${BASE}/api/v1/execution-profiles`, () => {
    return HttpResponse.json({
      items: executionProfiles,
      total: executionProfiles.length,
      limit: 50,
      offset: 0,
    });
  }),

  // ── Create execution profile ──────────────────────────────────────────────
  http.post(`${BASE}/api/v1/execution-profiles`, async ({ request }) => {
    const body = (await request.json()) as Record<string, unknown>;
    const created = {
      id: nextProfileId++,
      user_id: 42,
      name: (body['name'] as string) ?? 'New Profile',
      description: (body['description'] as string) ?? '',
      is_default: false,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      routes: [],
    };
    executionProfiles = [...executionProfiles, created];
    return HttpResponse.json(created, { status: 201 });
  }),

  // ── Get execution profile ────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/execution-profiles/:id`, ({ params }) => {
    const id = Number(params['id']);
    const profile = executionProfiles.find((p) => p.id === id);
    if (!profile)
      return HttpResponse.json({ detail: 'Execution profile not found' }, { status: 404 });
    return HttpResponse.json(profile);
  }),

  // ── Update execution profile ──────────────────────────────────────────────
  http.patch(`${BASE}/api/v1/execution-profiles/:id`, async ({ request, params }) => {
    const id = Number(params['id']);
    const body = (await request.json()) as object;
    executionProfiles = executionProfiles.map((p) =>
      p.id === id ? { ...p, ...body, updated_at: new Date().toISOString() } : p,
    );
    const updated = executionProfiles.find((p) => p.id === id);
    return HttpResponse.json(updated);
  }),

  // ── Delete execution profile ──────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/execution-profiles/:id`, ({ params }) => {
    const id = Number(params['id']);
    executionProfiles = executionProfiles.filter((p) => p.id !== id);
    return new HttpResponse(null, { status: 204 });
  }),

  // ── Add route to profile ──────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/execution-profiles/:id/routes`, async ({ request, params }) => {
    const profileId = Number(params['id']);
    const body = (await request.json()) as Record<string, unknown>;
    const route = {
      id: nextRouteId++,
      profile_id: profileId,
      symbol_pattern: (body['symbol_pattern'] as string) ?? '*',
      venue_connection_id: (body['venue_connection_id'] as number) ?? 1,
      priority: (body['priority'] as number) ?? 1,
      execution_mode: (body['execution_mode'] as string) ?? 'PAPER',
    };
    executionProfiles = executionProfiles.map((p) => {
      if (p.id !== profileId) return p;
      const routes = (p.routes as Array<Record<string, unknown>>) ?? [];
      return { ...p, routes: [...routes, route], updated_at: new Date().toISOString() };
    });
    return HttpResponse.json(route, { status: 201 });
  }),

  // ── Delete route from profile ─────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/execution-profiles/:id/routes/:routeId`, ({ params }) => {
    const profileId = Number(params['id']);
    const routeId = Number(params['routeId']);
    executionProfiles = executionProfiles.map((p) => {
      if (p.id !== profileId) return p;
      const routes = (p.routes as Array<Record<string, unknown>>) ?? [];
      return {
        ...p,
        routes: routes.filter((r) => r.id !== routeId),
        updated_at: new Date().toISOString(),
      };
    });
    return new HttpResponse(null, { status: 204 });
  }),
];
